import {motion} from "framer-motion"
import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Button
  } from '@chakra-ui/react'
  import {InputGroup,InputRightElement,Input,Avatar,Stack} from "@chakra-ui/react"
import {CgLogIn} from "react-icons/cg"
import {  useState } from "react";
import {Link,useNavigate, useSearchParams } from "react-router-dom"
import { FaBars, FaTimes } from "react-icons/fa";
import styled from "styled-components";
import {CgProfile} from "react-icons/cg"
import {BsCart2} from "react-icons/bs"
import { Icon } from "@chakra-ui/react";
import {SearchIcon} from "@chakra-ui/icons"
import wearwave from "../imgs/wearwave.png"
// import {useNavigate} from "react-router-dom"
import {AiOutlineShoppingCart} from "react-icons/ai"
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
// import { logout } from '../redux/authreducer/action';
import {LOGIN_FAILER} from "../redux/authRedux/actionType"
import {getData} from "../redux/productsRedux/action"

 const Navbar = () =>{
	
	const [navClass, setNavClass] = useState(false)
    // console.log(window.location.pathname);
	const [search, setSearch] = useState("")
	const [searchParams, setSearchParams] = useSearchParams()
	const navigate = useNavigate()
	const isAuth = useSelector((state)=> state.authReducer.isAuth) 
	const username = useSelector((state)=> state.authReducer.username) 
	console.log(username);
	const showNavbar = () => {
		setNavClass(!navClass)		
	};

	  
	  const dispatch = useDispatch()

	const handleLogOut = () =>{
			dispatch({type:LOGIN_FAILER})
			

	}
	const handleSearch =(e) =>{
		e.preventDefault()
		let params ={
			q : [search]
		}
		setSearchParams(params)
		dispatch(getData(params))
		navigate("/shop")
		
		// window.location.reload()
	}
	
const navgite = useNavigate()
	return <HEADER>
    <header 

	>


			
			<Link to="/"> <img className="logo" alt="logo" src={wearwave} /> </Link>


			<div className= {"secNav"} >
			{/* ref={navRef} */}
			<nav className= {navClass ? "responsive_nav" : "false"} >
				 
        
             <Link to="/mens" >MENS</Link>
             
             
                 <Link to="/women" >WOMEN</Link>
             
             
                 <Link to="/shoes" >SHOES</Link>
             
             
                 <Link to="/" >HOME & LIVING</Link>
             
             
                 <Link to="/beauty" >BEAUTY</Link>
             
             
                 <Link to="/shop" >SHOP</Link>
        
                
				<button className="nav-btn nav-close-btn" 
          onClick={showNavbar}>
						{/* onClick={showNavbar} */}
					<Icon as={FaTimes} />
				</button>
				{/* -------------------------------------------------------I added search here------------------------- */}
				
			</nav>
            <div className="navIcons">
				<form onSubmit={handleSearch}>

				
			
					<InputGroup className="searchBar" bg="#f5f5f6" size='sm'>
         <InputRightElement width='4.5rem'>
         <Button type="submit" className="searchBtn"  h='1.75rem' bg="#f5f5f6" size='sm' >
             <SearchIcon    />
         </Button>
       </InputRightElement>
       <Input  
	   onChange={(e)=>setSearch(e.target.value)}
        pr='4.5rem'
		className="searchInput"
		value= {search}
        placeholder='Search for Product, Brands and more'
      />
      
    </InputGroup>
	</form>
					<Link to="/cart">
					<Icon as={BsCart2}/>
					</Link>
                    {
						isAuth ? <Menu>
						{({ isOpen }) => (
						  <div>
							<MenuButton isActive={isOpen} as={Button}   >
							  {isOpen ? <Icon size={30} as={CgProfile} /> : <Icon as={CgProfile} size={30} />}
							</MenuButton>
							<MenuList style= {{display:"flex", flexDirection:"column"}}>
							<MenuItem color={"black"} >{username }</MenuItem>
							  <MenuItem color={"black"} onClick={()=> {
								navgite("/admin")
							  }}>Admin</MenuItem>
							  <MenuItem color={"black"} onClick={handleLogOut}>Log Out</MenuItem>
							</MenuList>
						  </div>
						)}
					  </Menu> : <Link to="/login">
                    <Icon as={CgLogIn}/>
					</Link>

					}
					
                </div>
			<button onClick={showNavbar}
				className="nav-btn"
				 >
				
				<Icon as={FaBars} size={10}  />
			</button>
			</div>
      </header>
		</HEADER>
	
}


const HEADER = styled.div`
  

* {
	padding: 0;
	margin: 0;
	/* padding-top: 20px; */
	box-sizing: border-box;
	font-family: "Titillium Web", sans-serif;
    /* outline: black; */
}
/* padding-bottom: ${window.location.pathname === "/" ? "0" : "60px"}; */
padding-bottom: 60px;
 z-index: 1;
 /* background-color: #283593;  button */

header {
	/* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 70px;
	padding: 0 10px;
	/* margin-bottom: 20px; */
	/* margin-bottom: 20px; */
	/* padding-bottom:20px; */
	background-color: white;
	/* background-color: white */
	color: black;
	font-weight: 200;
	font-size: small;
	position:absolute;
	z-index: 100;
	width: 100%;
}

nav a {
	margin: 0 1rem;
	color: black;
	font-weight: 600;

	text-decoration: none;
}

nav a:hover {
	color: black;
	scale: 1.1;
	transition: 500ms;
	text-decoration: solid underline   #283593;

}

header .nav-btn {
	padding: 5px 10px;
	cursor: pointer;
	background: transparent;
	border: none;
	outline: none;
	color: black;
	visibility: hidden;
	opacity: 0;
	font-size: 20px;
}

header div,
nav {
	display: flex;
    width: fit-content;
    /* margin: auto; */
	align-items: center;
    /* justify-content: center; */
}
nav{
    margin: auto;
}

.blackDot{
    background-color: rgb(101, 101, 101);
    height: 5px;
    width: 5px;
    border-radius: 50%;
}

.lodo{
    font-size: larger;
    width: fit-content;
}
.navIcons{
    display: flex;
    gap: 20px;
    width: fit-content;
    font-size: 20px;
}
.logo{
	height: 40px;
	border-radius: 10px;
	/* border: 1px solid blue; */
	/* padding: -5px; */
}

.beforeSearch{
	border-radius: 10px;
	width: 0px;
	font-size: small;
	padding:  10px;
	visibility: hidden;
	transition: 0.4s;
}
.navSearch{
	visibility: visible;
	width: 200px;
	transition: 0.5s;
}

@media (max-width: 480px) {
	.logo{
		height: 25px;
		margin-right: 40px;
	}
	
	header .nav-btn {
		visibility: visible;
		opacity: 1;
	}

	header nav {
		position: fixed;
		top: -110vh;
		left: 0;
		padding:20px;
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		z-index: 100;
		justify-content: center;
		gap: 1.5rem;
		background-color: black;
        color: white;
		transition: 1s;
	}

	header .responsive_nav {
		transform: translateY(110vh);
	}

	nav .nav-close-btn {
		position: absolute;
		top: 2rem;
		right: 2rem;
        color: white;
        /* background-color: aliceblue; */
	}

	nav a {
        color: white;
		font-size: 1.5rem;
	}
	.searchBar{
		height: 20px;
		/* border: 1px solid black; */

		width: fit-content;
	}
	.searchBtn{
		/* border: 1px solid black; */
		height:20px;
		margin:0px;
		margin-top: -10px;
		padding: 2px
	}
	.searchInput{
		/* border: 1px solid black; */

		font-size: small;
		width: 130px;
		/* padding: 5px; */
		height: 25px
	}
	
}

@media (min-width: 481px) and (max-width: 1024px){
	header {
	/* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 70px;
	padding: 0 10px;
	/* margin-bottom: 20px; */
	/* margin-bottom: 20px; */
	/* padding-bottom:20px; */
	background-color: white;
	/* background-color: white */
	color: black;
	font-size: x-small;
	position:absolute;
	z-index: 100;
	width: 100%;
}
.chakra-button, .chakra-menu__menu-button, .css-i857na{
	font-size: small;
	padding: 0px;
}

}
`


export default Navbar